import ComponentWithSocket from '../../../lib/component';
import { Component, Watch } from 'vue-property-decorator';

import Docxtemplater from 'docxtemplater';
import PizZip from 'pizzip';
import PizZipUtils from 'pizzip/utils/index.js';
import ImageModule from 'docxtemplater-image-module-free';
import { saveAs } from 'file-saver';
import https from 'https';
import Stream from 'stream';

import * as Store from '../../../store';
import * as Stock from '../../../utils/stock';
import DepositorForm from '../../../components/depositor-form/depositor-form.vue';
import {
    depositorDocxData,
    depositorName,
    depositorOptions,
    emptyDepositor,
} from '../../../utils/depositor';
import { canAccessStock } from '../../../utils/access';
import { contractLabel } from '../../../utils/export';
import {
    LotSuggestions,
    emptyLotSuggestions,
} from '../../../utils/lot-suggestions';
import { slugify } from '../../../commons/slug';

import moment from 'moment';
import 'moment/locale/ro';
moment.locale('ro');

/**
 * Formularul gol de lot. Serveste si ca baza la editare, ca fiecare camp sa
 * aiba valoare: `vue-typeahead-bootstrap` nu emite `input` pe `undefined`.
 */
function emptyLot() {
    return {
        name: '',
        slug: '',
        description: '',
        startingPrice: 0,
        reservedPrice: 0,
        estimateMin: 0,
        estimateMax: 0,
        type: '',
        fabricOrTechnique: '',
        dimensions: '',
        image: '' as any,
        technicalDetails: '',
        restoration: '',
        author: '',
        authorName: '',
        authorInfo: '',
    };
}

const MOVE_TO_EXISTING = 'existing';
const MOVE_TO_NEW = 'new';

/** Formularul de mutare a contractului pe alt deponent, gol. */
function emptyMove() {
    return {
        open: false,
        submitting: false,
        mode: MOVE_TO_EXISTING,
        selected: undefined as any,
        depositor: emptyDepositor(),
        error: '',
    };
}

@Component({
    components: { DepositorForm },
})
export default class DepositorsManage extends ComponentWithSocket {
    public data: {
        id: string;
        addLotError: string;
        addLotOpen: boolean;
        updateLotError: string;
        updateLotOpen: boolean;
        updateLotId: string;
        contract: any;
        lots: any[];
        transfers: any[];
        authors: any[];
        lotSuggestions: LotSuggestions;
        lotImageOpen: boolean;
        lotImageLightbox: any;
        auctions: any[];
        selectedAuction: any;
        isLoadingAuctions: boolean;
        selectedLots: any[];
        addLotsToAuctionOpen: boolean;
        contracts: any[];
        depositors: any[];
        isLoadingDepositors: boolean;
        move: ReturnType<typeof emptyMove>;
        attachments: any[];
        signing: {
            open: boolean;
            submitting: boolean;
            email: string;
            subject: string;
            message: string;
            error: string;
            success: string;
        };
        signingTokens: any[];
        signingTokensCopied: { [k: string]: boolean };
        lastGenerated: {
            open: boolean;
            tokenId: string;
            signingUrl: string;
            previewPdfUrl: string;
            copied: boolean;
        };
        tokenEmail: {
            open: boolean;
            submitting: boolean;
            tokenId: string;
            email: string;
            subject: string;
            message: string;
            error: string;
            success: string;
        };
    } = {
        id: '',
        addLotError: '',
        addLotOpen: false,
        updateLotError: '',
        updateLotOpen: false,
        updateLotId: '',
        contract: undefined,
        lots: [],
        transfers: [],
        authors: [],
        lotSuggestions: emptyLotSuggestions(),
        lotImageOpen: false,
        lotImageLightbox: '',
        auctions: [],
        selectedAuction: undefined,
        isLoadingAuctions: false,
        selectedLots: [],
        addLotsToAuctionOpen: false,
        contracts: [],
        depositors: [],
        isLoadingDepositors: false,
        move: emptyMove(),
        attachments: [],
        signing: {
            open: false,
            submitting: false,
            email: '',
            subject: '',
            message: '',
            error: '',
            success: '',
        },
        signingTokens: [],
        signingTokensCopied: {},
        lastGenerated: {
            open: false,
            tokenId: '',
            signingUrl: '',
            previewPdfUrl: '',
            copied: false,
        },
        tokenEmail: {
            open: false,
            submitting: false,
            tokenId: '',
            email: '',
            subject: '',
            message: '',
            error: '',
            success: '',
        },
    };

    public addLot: ReturnType<typeof emptyLot> = emptyLot();

    readonly moveModes = [
        { value: MOVE_TO_EXISTING, text: 'Deponent existent' },
        { value: MOVE_TO_NEW, text: 'Deponent nou' },
    ];

    activeTabIndex: number = 0;

    get nextContractPath(): string | undefined {
        const current = this.data.contract;
        const contracts = this.data.contracts;

        if (!current || !contracts || !contracts.length) {
            return undefined;
        }

        const sorted = [...contracts].sort((a: any, b: any) => {
            const aYear = a.signedAt ? new Date(a.signedAt).getFullYear() : 0;
            const bYear = b.signedAt ? new Date(b.signedAt).getFullYear() : 0;
            if (aYear !== bYear) return bYear - aYear;
            return (b.number || 0) - (a.number || 0);
        });

        const currentIndex = sorted.findIndex(
            (c: any) => c._id === current._id,
        );

        if (currentIndex === -1 || currentIndex === sorted.length - 1) {
            return undefined;
        }

        const next = sorted[currentIndex + 1];
        return next && next._id ? `/depositors/manage/${next._id}` : undefined;
    }

    constructor() {
        super();

        this.wsListener.onGet(
            'admin.depositors.contracts',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (success) {
                    if (Array.isArray(data)) {
                        this.data.contracts = data;
                    } else {
                        this.data.contract = data;
                    }
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors.contracts.lots',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (success) {
                    let lots = [];
                    this.data.lots = data;
                    data.forEach((lot: any) => {
                        lot.attributes.forEach((attr: any) => {
                            switch (attr.name) {
                                case 'Tip Lot':
                                    lot.type = attr.value;
                                    break;
                                case 'Material / Tehnica':
                                    lot.fabricOrTechnique = attr.value;
                                    break;
                                case 'Dimensiuni':
                                    lot.dimensions = attr.value;
                                    break;
                                case 'Semnatura':
                                    lot.signature = attr.value;
                                    break;
                                case 'Datat':
                                    lot.dated = attr.value;
                                    break;
                            }
                        });

                        lots.push(lot);
                    });

                    this.wsListener.sendGet(
                        'admin.depositors.contracts.authors',
                    );
                    this.wsListener.sendGet(
                        'admin.depositors.contracts.lots.suggestions',
                    );
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors.contracts.transfers',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.transfers = data || [];
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors.contracts.authors',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.authors = data;
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors.contracts.lots.suggestions',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.lotSuggestions = data;
                }
            },
        );

        this.wsListener.onPost(
            'admin.depositors.contracts.lots',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.addLotError = '';
                    this.data.addLotOpen = false;
                    this.resetAddLotDetails();

                    this.wsListener.sendGet('admin.depositors.contracts.lots', {
                        contract: this.data.id,
                    });
                } else {
                    this.data.addLotError = data;
                }
            },
        );

        this.wsListener.onPut(
            'admin.depositors.contracts.lots',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.updateLotError = '';
                    this.data.updateLotOpen = false;
                    this.resetAddLotDetails();
                    this.wsListener.sendGet('admin.depositors.contracts.lots', {
                        contract: this.data.id,
                    });
                } else {
                    this.data.updateLotError = data;
                }
            },
        );

        // Comutarea stocului trece prin routerul de stocuri, deci raspunsul
        // vine in forma folosita acolo. Actualizam doar campurile de stoc pe
        // randul existent, ca sa nu pierdem atributele aplatizate mai sus.
        this.wsListener.onPut('stock.lot', (success: boolean, data: any) => {
            Store.commitLoaderVisibility(this.$store, false);

            if (!success) {
                return alert(data);
            }

            const lot = this.data.lots.find(
                (item: any) => String(item._id) === String(data.lot._id),
            );

            if (lot) {
                this.$set(lot, 'inStock', data.lot.inStock);
                this.$set(lot, 'stockChangedAt', data.lot.stockChangedAt);
                this.$set(lot, 'stockChangedBy', data.lot.stockChangedBy);
            }
        });

        this.wsListener.onPut(
            'admin.depositors.contracts',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (!success) {
                    console.error(data);
                }
            },
        );

        this.wsListener.onPut(
            'admin.depositors',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (!success) {
                    console.error(data);
                    alert(
                        typeof data === 'string'
                            ? data
                            : 'Deponentul nu a putut fi actualizat.',
                    );
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors',
            (success: boolean, data: any) => {
                this.data.isLoadingDepositors = false;

                if (success) {
                    this.data.depositors = data;
                }
            },
        );

        this.wsListener.onPut(
            'admin.depositors.contracts.depositor',
            (success: boolean, data: any) => {
                this.data.move.submitting = false;

                if (!success) {
                    this.data.move.error =
                        typeof data === 'string'
                            ? data
                            : 'Contractul nu a putut fi mutat.';
                    return;
                }

                this.data.contract = data;
                this.data.move = emptyMove();
                // Deponentul nou creat trebuie sa apara la urmatoarea alegere.
                this.data.depositors = [];
                this.refreshSigningTokens();
            },
        );

        this.wsListener.onDelete(
            'admin.depositors.contracts.lots',
            (success: boolean, data: any) => {
                if (success) {
                    this.wsListener.sendGet('admin.depositors.contracts.lots', {
                        contract: this.data.id,
                    });
                } else {
                    Store.commitLoaderVisibility(this.$store, false);
                    console.error(data);
                    alert(
                        typeof data === 'string'
                            ? data
                            : 'Lotul nu a putut fi sters.',
                    );
                }
            },
        );

        this.wsListener.onGet('auctions', (success: boolean, data: any) => {
            this.data.isLoadingAuctions = false;
            if (success) {
                this.data.auctions = [];
                for (let auction of data.reverse()) {
                    auction.startDate = auction.startDate
                        ? moment(auction.startDate)
                        : undefined;
                    if (auction.startDate && auction.startDate > moment()) {
                        this.data.auctions.push(auction);
                    }
                }
            }
        });

        this.wsListener.onPost(
            'admin.auctions.lots',
            (success: boolean, data: any) => {
                Store.commitLoaderVisibility(this.$store, false);

                if (success) {
                    alert(
                        this.data.selectedLots.length === 1
                            ? 'Lotul a fost adaugat cu succes!'
                            : 'Loturile au fost adaugate cu succes!',
                    );

                    this.data.addLotsToAuctionOpen = false;
                    this.data.selectedLots = [];
                    this.data.selectedAuction = undefined;
                } else {
                    console.error(data);
                }
            },
        );

        this.wsListener.onPost(
            'admin.depositors.contracts.send-for-signing',
            (success: boolean, data: any) => {
                this.data.signing.submitting = false;

                if (success) {
                    this.data.signing.error = '';
                    this.data.signing.success =
                        'Email-ul a fost trimis cu succes!';
                    setTimeout(() => {
                        this.data.signing.open = false;
                        this.data.signing.success = '';
                    }, 1200);
                    // Refresh tokens list after generation
                    this.refreshSigningTokens();
                } else {
                    this.data.signing.success = '';
                    this.data.signing.error =
                        typeof data === 'string'
                            ? data
                            : 'A aparut o eroare la trimitere.';
                }
            },
        );

        this.wsListener.onPost(
            'admin.depositors.contracts.signing-tokens',
            (success: boolean, data: any) => {
                this.data.signing.submitting = false;

                if (success && data) {
                    this.data.signing.error = '';
                    this.data.signing.success = '';
                    this.data.signing.open = false;
                    this.data.lastGenerated.tokenId = data.tokenId || '';
                    this.data.lastGenerated.signingUrl = data.signingUrl || '';
                    this.data.lastGenerated.previewPdfUrl =
                        data.previewPdfUrl || '';
                    this.data.lastGenerated.copied = false;
                    this.data.lastGenerated.open = true;
                    this.refreshSigningTokens();
                } else {
                    this.data.signing.error =
                        typeof data === 'string'
                            ? data
                            : 'Nu am putut genera link-ul.';
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors.contracts.signing-tokens',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.signingTokens = Array.isArray(data)
                        ? data
                        : [];
                }
            },
        );

        this.wsListener.onPost(
            'admin.depositors.contracts.signing-tokens.send-email',
            (success: boolean, data: any) => {
                this.data.tokenEmail.submitting = false;
                if (success) {
                    this.data.tokenEmail.error = '';
                    this.data.tokenEmail.success =
                        'Email-ul a fost trimis cu succes!';
                    setTimeout(() => {
                        this.data.tokenEmail.open = false;
                        this.data.tokenEmail.success = '';
                    }, 1200);
                    this.refreshSigningTokens();
                } else {
                    this.data.tokenEmail.success = '';
                    this.data.tokenEmail.error =
                        typeof data === 'string'
                            ? data
                            : 'A aparut o eroare la trimitere.';
                }
            },
        );

        this.wsListener.onPost(
            'admin.depositors.contracts.signing-tokens.revoke',
            (success: boolean, data: any) => {
                if (success) {
                    this.refreshSigningTokens();
                } else {
                    alert(
                        typeof data === 'string'
                            ? data
                            : 'Nu am putut invalida link-ul.',
                    );
                }
            },
        );

        this.wsListener.onGet(
            'admin.depositors.contracts.attachments',
            (success: boolean, data: any) => {
                if (success) {
                    this.data.attachments = Array.isArray(data) ? data : [];
                }
            },
        );
    }

    @Watch('addLot.authorName')
    updateAuthorInfo(val: any) {
        this.addLot.author = '';
        const author = this.data.authors.find((el: any) => el.name === val);
        if (author) {
            this.addLot.author = author._id;
            this.addLot.authorInfo = author.info || '';
        }
    }

    @Watch('data.contract')
    onContractLoaded(contract: any) {
        if (!contract || !contract.depositor) return;

        if (!this.data.signing.email) {
            this.data.signing.email = contract.depositor.email || '';
        }

        if (!this.data.signing.subject) {
            const numberPart = `${contract.number || ''}${
                contract.suffix ? '-' + contract.suffix : ''
            }`;
            const datePart = contract.signedAt
                ? moment(contract.signedAt).format('DD.MM.YYYY')
                : moment().format('DD.MM.YYYY');
            this.data.signing.subject = `Nr. ${numberPart} / ${datePart} VIKART - CONTRACT DE CONSIGNAȚIE pentru vânzare prin licitație online`;
        }

        if (!this.data.signing.message) {
            const fullName = depositorName(contract.depositor);
            this.data.signing.message =
                `Stimate client${fullName ? ', ' + fullName : ''},\n\n` +
                `Vă transmitem spre semnare:\nCONTRACT DE CONSIGNAȚIE pentru vânzare prin licitație online.\n\n` +
                `Vă rugăm să semnați electronic contractul accesând link-ul primit pe e-mail. Documentul este deja semnat de către noi, iar dvs. îl puteți semna foarte simplu, direct de pe telefon, tabletă sau calculator, folosind mouse-ul ori ecranul tactil.\n\n` +
                `Vă mulțumim pentru colaborare!`;
        }

        this.wsListener.sendGet('admin.depositors.contracts.attachments', {
            contractId: contract._id,
        });

        this.refreshSigningTokens();
    }

    refreshSigningTokens() {
        if (!this.data.contract || !this.data.contract._id) return;
        this.wsListener.sendGet(
            'admin.depositors.contracts.signing-tokens',
            { contractId: this.data.contract._id },
        );
    }

    openSendForSigning() {
        this.data.signing.error = '';
        this.data.signing.success = '';
        this.data.signing.submitting = false;
        this.data.signing.open = true;
    }

    generateSigningLinkOnly() {
        if (!this.data.contract || !this.data.contract._id) return;
        this.data.signing.submitting = true;
        this.data.signing.error = '';
        this.data.signing.success = '';

        this.wsListener.sendPost(
            'admin.depositors.contracts.signing-tokens',
            { contractId: this.data.contract._id },
        );
    }

    generateSigningLinkAndSendEmail() {
        if (!this.data.contract || !this.data.contract._id) return;
        if (!this.data.signing.email) {
            this.data.signing.error =
                'Email-ul destinatarului este obligatoriu pentru a trimite.';
            return;
        }
        this.data.signing.submitting = true;
        this.data.signing.error = '';
        this.data.signing.success = '';

        this.wsListener.sendPost(
            'admin.depositors.contracts.send-for-signing',
            {
                contractId: this.data.contract._id,
                email: this.data.signing.email,
                subject: this.data.signing.subject,
                message: this.data.signing.message,
            },
        );
    }

    openSendEmailForToken(token: any) {
        this.data.tokenEmail.tokenId = token._id;
        this.data.tokenEmail.email =
            token.email ||
            (this.data.contract && this.data.contract.depositor
                ? this.data.contract.depositor.email
                : '') ||
            '';
        this.data.tokenEmail.subject = '';
        this.data.tokenEmail.message = '';
        this.data.tokenEmail.error = '';
        this.data.tokenEmail.success = '';
        this.data.tokenEmail.submitting = false;
        this.data.tokenEmail.open = true;
    }

    sendEmailForToken() {
        if (!this.data.tokenEmail.tokenId || !this.data.tokenEmail.email) {
            this.data.tokenEmail.error = 'Email-ul este obligatoriu.';
            return;
        }
        this.data.tokenEmail.submitting = true;
        this.data.tokenEmail.error = '';
        this.data.tokenEmail.success = '';

        this.wsListener.sendPost(
            'admin.depositors.contracts.signing-tokens.send-email',
            {
                tokenId: this.data.tokenEmail.tokenId,
                email: this.data.tokenEmail.email,
                subject: this.data.tokenEmail.subject,
                message: this.data.tokenEmail.message,
            },
        );
    }

    revokeSigningToken(token: any) {
        if (!token || !token._id) return;
        const url: string = token.signingUrl || '';
        if (
            !confirm(
                'Sigur vrei sa invalidezi acest link? Daca a fost trimis, clientul nu mai poate semna pe el.\n\n' +
                    url,
            )
        ) {
            return;
        }
        this.wsListener.sendPost(
            'admin.depositors.contracts.signing-tokens.revoke',
            { tokenId: token._id },
        );
    }

    copyToClipboard(text: string, tokenId?: string) {
        if (!text) return;
        const onCopied = () => {
            if (tokenId) {
                this.$set(this.data.signingTokensCopied, tokenId, true);
                setTimeout(() => {
                    this.$set(this.data.signingTokensCopied, tokenId, false);
                }, 1500);
            } else {
                this.data.lastGenerated.copied = true;
                setTimeout(() => {
                    this.data.lastGenerated.copied = false;
                }, 1500);
            }
        };
        const nav: any = navigator;
        if (nav && nav.clipboard && nav.clipboard.writeText) {
            nav.clipboard
                .writeText(text)
                .then(onCopied)
                .catch(() => {
                    this._fallbackCopy(text);
                    onCopied();
                });
        } else {
            this._fallbackCopy(text);
            onCopied();
        }
    }

    _fallbackCopy(text: string) {
        try {
            const ta = document.createElement('textarea');
            ta.value = text;
            ta.style.position = 'fixed';
            ta.style.opacity = '0';
            document.body.appendChild(ta);
            ta.focus();
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
        } catch (e) {
            // best-effort
        }
    }

    signingStatusBadgeClass(status: string): string {
        switch (status) {
            case 'pending':
                return 'badge-warning';
            case 'opened':
                return 'badge-info';
            case 'signed':
                return 'badge-success';
            case 'revoked':
            case 'expired':
                return 'badge-secondary';
            default:
                return 'badge-light';
        }
    }

    signingStatusLabel(status: string): string {
        switch (status) {
            case 'pending':
                return 'In asteptare';
            case 'opened':
                return 'Deschis';
            case 'signed':
                return 'Semnat';
            case 'revoked':
                return 'Invalidat';
            case 'expired':
                return 'Expirat';
            default:
                return status || '-';
        }
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        this.data.id = this.$root.$route.params.id;

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('admin.depositors.contracts', {
            _id: this.data.id,
        });

        // Incarca toate contractele pentru a putea naviga la urmatorul
        this.wsListener.sendGet('admin.depositors.contracts');

        this.wsListener.sendGet('admin.depositors.contracts.lots', {
            contract: this.data.id,
        });

        this.wsListener.sendGet('admin.depositors.contracts.transfers', {
            contract: this.data.id,
        });

        this.wsListener.sendGet('admin.depositors.contracts.authors');
    }

    depositorName = depositorName;
    contractLabel = contractLabel;

    /** Celelalte contracte ale deponentului, afectate de editarea datelor lui. */
    get otherDepositorContractsCount(): number {
        const contract = this.data.contract;

        return this.data.contracts.filter(
            (item: any) =>
                item._id !== contract._id &&
                item.depositor &&
                item.depositor._id === contract.depositor._id,
        ).length;
    }

    get isContractSigned(): boolean {
        return this.data.contract.status == 1;
    }

    get isMoveToExisting(): boolean {
        return this.data.move.mode === MOVE_TO_EXISTING;
    }

    get moveDepositorOptions() {
        return depositorOptions(
            this.data.depositors,
            this.data.contract.depositor._id,
        );
    }

    // Aceleasi reguli de afisare a stocului ca in zona Stocuri.
    formatSku = Stock.formatSku;
    stockLabel = Stock.stockLabel;
    stockBadgeClass = Stock.stockBadgeClass;
    canSetInStock = Stock.canSetInStock;
    canSetOutOfStock = Stock.canSetOutOfStock;

    /** Doar cine are drept de stoc poate comuta starea din acest tabel. */
    get canChangeStock(): boolean {
        return canAccessStock(Store.readLoggedInUser(this.$store));
    }

    beautifyDateTime(dtt: any) {
        return moment(dtt).format('llll');
    }

    stockChangedAtLabel(lot: any): string {
        return lot.stockChangedAt
            ? moment(lot.stockChangedAt).format('DD.MM.YYYY HH:mm')
            : '';
    }

    stockChangedByLabel(lot: any): string {
        const user = lot.stockChangedBy;
        if (!user || !user._id) return '';

        return `${user.firstName || ''} ${user.lastName || ''}`.trim();
    }

    resetAddLotDetails() {
        let $this: any = this;

        this.addLot = emptyLot();

        setTimeout(() => {
            $this.$refs.lotImage.value = '';
            $this.$refs.authorTypeaheadEdit.inputValue = this.addLot.authorName;
        });
    }

    updateContract() {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPut('admin.depositors.contracts', {
            _id: this.data.id,
            status: this.data.contract.status,
            number: this.data.contract.number,
            suffix: this.data.contract.suffix,
            signedAt: this.data.contract.signedAt,
        });
    }

    addContractLot() {
        let lot: any = this.addLot;
        lot.contract = this.data.id;

        this.wsListener.sendPost('admin.depositors.contracts.lots', lot);
        Store.commitLoaderVisibility(this.$store, true);
    }

    openLotLightbox(image: any) {
        this.data.lotImageOpen = true;
        this.data.lotImageLightbox = image.imagesData[0].thumbnail;
    }

    updateLot(lot: any) {
        let $this: any = this;
        this.data.updateLotId = lot._id;
        this.data.updateLotOpen = true;

        this.addLot = Object.assign(
            emptyLot(),
            {
                authorName: lot.author ? lot.author.name : '',
                authorInfo: lot.author ? lot.author.info : '',
            },
            lot,
        );

        if (!this.addLot.slug) {
            const authorName = this.addLot.authorName || '';
            this.addLot.slug = slugify(
                authorName
                    ? `${authorName} ${this.addLot.name}`
                    : this.addLot.name,
            );
        }

        setTimeout(() => {
            $this.$refs.lotImage.value = '';
            $this.$refs.authorTypeaheadEdit.inputValue = this.addLot.authorName;
        });
    }

    cancelUpdateLot() {
        let $this: any = this;
        this.data.updateLotId = '';
        this.data.updateLotOpen = false;
        $this.$refs.lotImage.value = '';
        this.resetAddLotDetails();
    }

    doUpdateLot() {
        this.wsListener.sendPut('admin.depositors.contracts.lots', {
            _id: this.data.updateLotId,
            lot: this.addLot,
            contract: this.data.id,
        });
        Store.commitLoaderVisibility(this.$store, true);
    }

    doDeleteLot(lot: any) {
        if (!confirm('Esti sigur ca vrei sa stergi acest lot?')) {
            return;
        }

        this.wsListener.sendDelete('admin.depositors.contracts.lots', {
            _id: lot._id,
        });
        Store.commitLoaderVisibility(this.$store, true);
    }

    /** Etichetele cu cod QR pentru toate loturile contractului. */
    printContractLabels() {
        this.$router.push(`/etichete?contract=${this.data.contract._id}`);
    }

    printSelectedLabels() {
        const ids = this.data.selectedLots.map((lot: any) => lot._id).join(',');
        this.$router.push(`/etichete?lots=${ids}`);
    }

    printLotLabel(lot: any) {
        this.$router.push(`/etichete?lots=${lot._id}`);
    }

    /** Deschide fisa de stoc a lotului, cu istoricul miscarilor. */
    openLotStock(lot: any) {
        this.$router.push(`/stocuri/lot/${lot.sku}`);
    }

    /**
     * Comuta stocul folosind acelasi eveniment ca zona Stocuri, ca sa existe
     * o singura implementare care scrie si istoricul miscarilor.
     */
    setLotStock(lot: any, inStock: boolean) {
        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendPut('stock.lot', {
            _id: lot._id,
            inStock,
        });
    }

    doUpdateDepositor() {
        this.wsListener.sendPut(
            'admin.depositors',
            this.data.contract.depositor,
        );
        Store.commitLoaderVisibility(this.$store, true);
    }

    openMoveContract() {
        this.data.move = emptyMove();
        this.data.move.open = true;

        if (!this.data.depositors.length) {
            this.data.isLoadingDepositors = true;
            this.wsListener.sendGet('admin.depositors');
        }
    }

    doMoveContract() {
        const move = this.data.move;
        const contract = this.data.contract;
        const toExisting = this.isMoveToExisting;

        if (toExisting && !move.selected) {
            move.error = 'Alege deponentul pe care muti contractul.';
            return;
        }

        const target = toExisting
            ? move.selected.label
            : depositorName(move.depositor) || 'deponentul nou';

        if (
            !confirm(
                `Contractul nr. ${contract.number}${
                    contract.suffix ? '-' + contract.suffix : ''
                } trece de pe ${depositorName(
                    contract.depositor,
                )} pe ${target}.\n\nLink-urile de semnare active se invalideaza.`,
            )
        ) {
            return;
        }

        move.error = '';
        move.submitting = true;

        this.wsListener.sendPut(
            'admin.depositors.contracts.depositor',
            toExisting
                ? { contractId: contract._id, depositorId: move.selected.value }
                : { contractId: contract._id, depositor: move.depositor },
        );
    }

    setLotImage(id: string) {
        let input: any = document.getElementById(id),
            $this: any = this;

        if (input.files && input.files[0]) {
            let FR = new FileReader();

            FR.addEventListener('load', function(e: any) {
                $this.addLot = Object.assign({}, $this.addLot, {
                    image: e.target.result,
                });
            });

            FR.readAsDataURL(input.files[0]);
        }
    }

    getAuctions() {
        this.data.selectedAuction = undefined;
        this.data.isLoadingAuctions = true;
        this.wsListener.sendGet('auctions');
    }

    addLotsToAuction() {
        this.wsListener.sendPost('admin.auctions.lots', {
            auction: this.data.auctions.find(
                (a: any) => a._id === this.data.selectedAuction.value,
            ),
            lots: this.data.selectedLots,
        });

        Store.commitLoaderVisibility(this.$store, true);
    }

    loadFile(url: string, callback: any) {
        PizZipUtils.getBinaryContent(url, callback);
    }

    replaceErrors(key: any, value: any) {
        if (value instanceof Error) {
            return Object.getOwnPropertyNames(value).reduce(
                (error: any, key: string) => {
                    error[key] = (value as any)[key];
                    return error;
                },
                {},
            );
        }

        return value;
    }

    getHttpData(url: any, callback: any) {
        url = url.replace(
            'storage.googleapis.com/vikart-production',
            'vikart-production.storage.googleapis.com',
        );

        https
            .request(url, function(response) {
                if (response.statusCode !== 200) {
                    return callback(
                        new Error(
                            `Request to ${url} failed, status code: ${
                                response.statusCode
                            }`,
                        ),
                    );
                }

                const data = new Stream.Transform();
                response.on('data', function(chunk) {
                    data.push(chunk);
                });
                response.on('end', function() {
                    callback(undefined, data.read());
                });
                response.on('error', function(e) {
                    callback(e);
                });
            })
            .on('error', function(e) {
                callback(e);
            })
            .end();
    }

    /** `getHttpData` ca promisiune; o poza care nu se poate descarca da `undefined`. */
    fetchImage(url: string): Promise<any> {
        return new Promise((resolve) => {
            this.getHttpData(url, (err: any, data: any) => {
                if (err) {
                    console.warn('Contract docx -> poza lipsa:', err.message);
                }
                resolve(err ? undefined : data);
            });
        });
    }

    /**
     * Descarca pozele loturilor inainte de randare. O poza lipsa din storage
     * (403) ar opri tot documentul cu "Multi error", asa ca lotul respectiv
     * iese fara poza - ca la PDF-ul de semnare din API.
     */
    async withLoadedImages(lots: any[]) {
        const images: { [url: string]: any } = {};
        const loadedLots: any[] = [];

        for (const lot of lots || []) {
            const imagesData: any[] = [];
            for (const image of lot.imagesData || []) {
                const url = image && image.thumbnail;
                if (!url) continue;
                if (!(url in images)) {
                    images[url] = await this.fetchImage(url);
                }
                if (images[url]) {
                    imagesData.push(image);
                }
            }
            loadedLots.push({ ...lot, imagesData });
        }

        return { lots: loadedLots, images };
    }

    doGenerateContract() {
        this.renderDocx(
            '/static/vikart_template_v4.docx',
            this.getContractDocxData(),
            this.getContractDocxFileName(),
        );
    }

    doGenerateCustodyContract() {
        this.renderDocx(
            '/static/contract_custodie_template_v1.docx',
            this.getContractDocxData(),
            'Custodie ' + this.getContractDocxFileName(),
        );
    }

    getContractDocxData() {
        const contract = this.data.contract;

        return {
            contract_number: contract.number,
            contract_suffix: contract.suffix ? '-' + contract.suffix : '',
            contract_date: moment(contract.signedAt).format('L'),
            ...depositorDocxData(contract.depositor),
            lots: this.data.lots,
        };
    }

    getContractDocxFileName() {
        const contract = this.data.contract;

        return (
            contract.number +
            (contract.suffix ? '-' + contract.suffix : '') +
            ' - ' +
            depositorName(contract.depositor) +
            '.docx'
        );
    }

    renderDocx(templateUrl: string, templateData: any, fileName: string) {
        let $this = this;

        $this.loadFile(templateUrl, async function(error: any, content: any) {
            if (error) {
                throw error;
            }

            const { lots, images } = await $this.withLoadedImages(
                templateData.lots,
            );

            // Below the options that will be passed to ImageModule instance
            let opts: any = {};
            opts.centered = false; // Set to true to always center images
            opts.fileType = 'docx'; // Or pptx

            opts.getImage = function(tagValue: any, tagName: any) {
                return images[tagValue];
            };
            opts.getSize = function(img: any, tagValue: any, tagName: any) {
                return [150, 150];
            };

            let imageModule = new ImageModule(opts);

            const options = {
                parser: function(tag: any) {
                    return {
                        get: function(scope: any, context: any) {
                            if (tag === '$index') {
                                const indexes = context.scopePathItem;
                                return indexes[indexes.length - 1] + 1;
                            }
                            return scope[tag];
                        },
                    };
                },
                modules: [imageModule],
            };

            let zip = new PizZip(content);
            let doc = new Docxtemplater(zip, options);

            // Get the right data and push it to the document
            await doc.resolveData({ ...templateData, lots });

            try {
                doc.render();
            } catch (error) {
                console.log(
                    JSON.stringify({ error: error }, $this.replaceErrors),
                );

                if (
                    error.properties &&
                    error.properties.errors instanceof Array
                ) {
                    const errorMessages = error.properties.errors
                        .map(function(error: any) {
                            return error.properties.explanation;
                        })
                        .join('\n');

                    console.log('errorMessages', errorMessages);
                }

                throw error;
            }

            let out = doc.getZip().generate({
                type: 'blob',
                mimeType:
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            }); // Output the document using Data-URI

            saveAs(out, fileName);
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/depositors/manage/index.ts